import type { OriginSource } from './constants.tsx';

export const jwmSampleProjectUrlWithOriginSource = (taskId: string, originSource: OriginSource) =>
	`/jira/core/sample/onboarding/${taskId}?originSource=moon-${originSource}`;
